
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const RakeMapAction = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        props.context.componentParent.onClickShowMap(props.data);
    };

    return (
        <div className="map-icon-component">
            <button onClick={handleRouteClick} className="custom-btn label label-success"><i className="icofont icofont-map-pins f20"></i> </button>
        </div>
    );
};

export default RakeMapAction;
